/**
 * Wheel Zoom for Shopify Product Images
 * Scroll the mouse wheel over a product image to zoom in/out,
 * centered on the cursor position.
 *
 * Usage: wrap your product <img> like this in the theme's Liquid file:
 *
 *   <div class="wheel-zoom-wrapper">
 *     <img class="wheel-zoom-img" src="..." ...>
 *   </div>
 *
 * Then include this file + wheel-zoom.css in your theme.
 */
(function () {
  const MIN_SCALE = 1;       // 100% = fit size
  const MAX_SCALE = 4;       // 400% max zoom
  const ZOOM_STEP = 0.0015;  // scroll sensitivity — raise for faster zoom

  function initWheelZoom(wrapper) {
    if (wrapper.dataset.wheelZoomInit) return; // avoid double-binding
    wrapper.dataset.wheelZoomInit = "true";

    const img = wrapper.querySelector(".wheel-zoom-img");
    if (!img) return;

    let scale = MIN_SCALE;
    let originX = 0.5; // relative 0–1 position of zoom origin
    let originY = 0.5;

    function applyTransform() {
      img.style.transformOrigin = originX * 100 + "% " + originY * 100 + "%";
      img.style.transform = "scale(" + scale + ")";
      wrapper.classList.toggle("is-zoomed", scale > MIN_SCALE);
    }

    wrapper.addEventListener(
      "wheel",
      function (e) {
        e.preventDefault(); // stop page scroll / browser zoom while over the image

        const rect = wrapper.getBoundingClientRect();
        originX = (e.clientX - rect.left) / rect.width;
        originY = (e.clientY - rect.top) / rect.height;

        const delta = -e.deltaY; // scroll up/away from you = zoom in
        let newScale = scale + delta * ZOOM_STEP * scale;
        newScale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, newScale));
        scale = newScale;

        applyTransform();
      },
      { passive: false }
    );

    // Reset to 100% when the cursor leaves the image
    wrapper.addEventListener("mouseleave", function () {
      scale = MIN_SCALE;
      originX = 0.5;
      originY = 0.5;
      applyTransform();
    });

    // Double-click to instantly reset
    wrapper.addEventListener("dblclick", function () {
      scale = MIN_SCALE;
      applyTransform();
    });
  }

  function initAll() {
    document.querySelectorAll(".wheel-zoom-wrapper").forEach(initWheelZoom);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Re-run after variant image swaps / section re-renders (theme editor, AJAX cart, etc.)
  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("variant:change", initAll);
})();
